import React, { useState } from 'react';
import { Col } from 'tea-component';

interface IProps {
  className?: string
  style?: any
  w?: number,
  children: any
  props: any
}


const CommonCol = (colProps: IProps) => {
  const { className = '', style, children, w, ...resetProps } = colProps || {};
  return (
    <Col className={className} style={style} span={w}>
      {React.Children.map(children, (child: any) => {
        return React.cloneElement(
          child,
          { ...resetProps }
        );
      })}
    </Col>
  );
};

export default CommonCol;
